import { Inject, Injectable } from '@angular/core';
import { RestDataService } from './rest-data.service';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

export class User {
    userId: string;
    email: string;
    firstName: string;
    surName: string;
}

//Manages the "claimed" user from a login and the user id in the pumpCalcApi
@Injectable({
  providedIn: 'root',}
)
export class UserService {

  private rootCollectionId:string;
  private user:User;
  userDetailsClaim:{
    email:string,
    firstName:string,
    surName:string
  }

  constructor(private restDataService:RestDataService, @Inject('app_config') private environment:any) {
    console.log(environment);
  }

  getUserId(){
    return this.user ?  this.user.userId : null;
  }

  getRootCollectionId(){
    return this.rootCollectionId;
  }

  setRootCollectionId(rootCollectionId:string){
    this.rootCollectionId = rootCollectionId;
  }

  getUserForEmail(email:string):Observable<User>{
    if(this.user) return of(this.user);
    return this.restDataService.get<User>((this.environment.app_config ? this.environment.app_config.userURL : this.environment.userURL) + "/" + email).pipe(tap(user=>{this.user = user}));
  }

  createUser(user:User){
    return this.restDataService.post<User>(this.environment.app_config ? this.environment.app_config.userURL : this.environment.userURL,this.user).pipe(tap(user=>{this.user = user}));
  }

  getUser():User {
    return this.user;
  }

  setUser():User {
    return this.user;
  }

  setUserDetailsClaim(email:string,firstName:string,surName:string){
    this.userDetailsClaim = {
      email:email,
      firstName:firstName,
      surName:surName,
    }
  }

  checkUserIsSetUp(email): Promise<boolean> {
    return new Promise((resolve) => {
      //if user already set, return quickly
      if (this.user) { resolve(true); return; }
      //otherwise check
      this.getUserForEmail(email).subscribe(
        result => {
          resolve(true);
        },
        error => {
          if (error.status == "404") {
            this.createUser({ userId: null, email: email, firstName: "", surName: ""}).subscribe(
              result => {
                resolve(true);
              },
              error => {
                console.log("Unable to create new user");
                resolve(false);
              }
            );
          }
        }
      )
    });
  }

}
